import { refreshContentActionsForPath } from './refreshContentActionsForPath';

/**
 * Refresh CMS content/actions after a successful login, before client redirect.
 * @returns {boolean} true when refresh was applied
 */
export function applyPostLoginRefresh(
  dispatch,
  { token, previousToken, returnUrl },
) {
  if (token && token !== previousToken) {
    refreshContentActionsForPath(dispatch, returnUrl || '/');
    return true;
  }
  return false;
}
